import React from 'react';

import { SubmitOrderButton } from './SubmitOrderButton';
import { TaxImpactPreviewInfoBanner } from './TaxImpactPreviewInfoBanner';

import { TaxImpactEstimateLoading } from '../../../../Shared/Components/tax-impact-preview/tax-impact-estimate/TaxImpactEstimateLoading';
import { TaxImpactGainLossLoading } from '../../../../Shared/Components/tax-impact-preview/tax-impact-gain-loss/TaxImpactGainLossLoading';
import { TaxImpactPreviewCard } from '../../../../Shared/Components/tax-impact-preview/TaxImpactPreviewCard';

export const TaxImpactPreviewLoading: React.FC = () => (
  <TaxImpactPreviewCard>
    <TaxImpactPreviewCard.DividedList>
      <TaxImpactEstimateLoading />
      <TaxImpactGainLossLoading />
    </TaxImpactPreviewCard.DividedList>
    <TaxImpactPreviewInfoBanner />
    <SubmitOrderButton disabled={true} />
  </TaxImpactPreviewCard>
);
